import { render, staticRenderFns } from "./ProductContents.vue?vue&type=template&id=48b4c9c4&scoped=true&"
import script from "./ProductContents.vue?vue&type=script&lang=js&"
export * from "./ProductContents.vue?vue&type=script&lang=js&"
import style0 from "./ProductContents.vue?vue&type=style&index=0&id=48b4c9c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4c9c4",
  null
  
)

export default component.exports